"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Entity_1 = require("./Entity");

var utils_1 = require("../utils");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var procedures_1 = require("../procedures");
/**
 * Check if the provided value is of type [[UniqueIdentifiers]]
 */


function isUniqueIdentifiers(identifiers) {
  var securityTokenId = identifiers.securityTokenId,
      stoType = identifiers.stoType,
      address = identifiers.address;
  return typeof securityTokenId === 'string' && typeof address === 'string' && types_1.isStoType(stoType);
}
/**
 * Abstract class used as a base to manage sto functionalities
 */


var Sto =
/*#__PURE__*/
function (_Entity_1$Entity) {
  _inherits(Sto, _Entity_1$Entity);

  /**
   * Create a new sto instance
   */
  function Sto(params, context) {
    var _this;

    _classCallCheck(this, Sto);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sto).call(this));
    /**
     * Pause the offering
     */

    _this.pause = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.TogglePauseSto({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  pause: true
                }, this.context);
                return _context.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Unpause the offering
     */


    _this.unpause = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.TogglePauseSto({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  pause: false
                }, this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Finalize the offering. The offering's treasury wallet (or the Security Token's treasury wallet if one was not specified for the offering)
     * will receive the remaining unsold tokens. Throws an error if there are transfer restrictions which do not permit the wallet to receive that amount of tokens
     */


    _this.finalize = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.FinalizeSto({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol
                }, this.context);
                return _context3.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Enable all offered tokens to be issued instantly at STO start (default behavior is to issue on purchase)
     * Can be disabled *BEFORE* the STO starts by calling disallowPreIssuing
     */


    _this.allowPreIssuing = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.ToggleAllowPreIssuing({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  allowPreIssuing: true
                }, this.context);
                return _context4.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };
    /**
     * Disable pre-issuing of offered tokens at STO start (goes back to default behavior, which is to issue on purchase)
     * Can be re-enabled *BEFORE* the STO starts by calling allowPreIssuing
     */


    _this.disallowPreIssuing = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.ToggleAllowPreIssuing({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  allowPreIssuing: false
                }, this.context);
                return _context5.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
    /**
     * Enable a party to invest in the STO on behalf of another party
     */


    _this.allowBeneficialInvestments = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.ToggleAllowBeneficialInvestments({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  allowBeneficialInvestments: true
                }, this.context);
                return _context6.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    };
    /**
     * Disable the possibility for a party to invest in the STO on behalf of another party
     */


    _this.disallowBeneficialInvestments = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var stoAddress, stoType, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                stoAddress = this.address, stoType = this.stoType, symbol = this.securityTokenSymbol;
                procedure = new procedures_1.ToggleAllowBeneficialInvestments({
                  stoAddress: stoAddress,
                  stoType: stoType,
                  symbol: symbol,
                  allowBeneficialInvestments: false
                }, this.context);
                return _context7.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
    };
    /**
     * Assign a role on the STO to a delegate
     *
     * @param args.delegateAddress - wallet address of the delegate
     * @param args.role - role to assign
     * @param args.description - description of the delegate (defaults to empty string, is ignored if the delegate already exists)
     */


    _this.assignRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var symbol, address, procedure;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                symbol = this.securityTokenSymbol, address = this.address;
                procedure = new procedures_1.AssignStoRole(Object.assign({
                  symbol: symbol,
                  assign: true,
                  stoAddress: address
                }, args), this.context);
                return _context8.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    };
    /**
     * Remove a role from a delegate
     *
     * @param args.delegateAddress - wallet address of the delegate
     * @param args.role - role to revoke
     */


    _this.revokeRole = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var symbol, address, procedure;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                symbol = this.securityTokenSymbol, address = this.address;
                procedure = new procedures_1.AssignStoRole(Object.assign({
                  symbol: symbol,
                  assign: false,
                  stoAddress: address
                }, args), this.context);
                return _context9.abrupt("return", procedure.prepare());

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    };

    var address = params.address,
        securityTokenSymbol = params.securityTokenSymbol,
        securityTokenId = params.securityTokenId,
        stoType = params.stoType,
        fundraiseCurrencies = params.fundraiseCurrencies,
        startDate = params.startDate,
        endDate = params.endDate,
        raisedFundsWallet = params.raisedFundsWallet,
        unsoldTokensWallet = params.unsoldTokensWallet,
        raisedAmount = params.raisedAmount,
        soldTokensAmount = params.soldTokensAmount,
        investorCount = params.investorCount,
        isPaused = params.isPaused,
        capReached = params.capReached,
        isFinalized = params.isFinalized,
        preIssueAllowed = params.preIssueAllowed,
        beneficialInvestmentsAllowed = params.beneficialInvestmentsAllowed;
    _this.address = address;
    _this.securityTokenSymbol = securityTokenSymbol;
    _this.securityTokenId = securityTokenId;
    _this.stoType = stoType;
    _this.startDate = startDate;
    _this.endDate = endDate;
    _this.raisedFundsWallet = raisedFundsWallet;
    _this.unsoldTokensWallet = unsoldTokensWallet;
    _this.raisedAmount = raisedAmount;
    _this.soldTokensAmount = soldTokensAmount;
    _this.investorCount = investorCount;
    _this.fundraiseCurrencies = fundraiseCurrencies;
    _this.isPaused = isPaused;
    _this.capReached = capReached;
    _this.isFinalized = isFinalized;
    _this.preIssueAllowed = preIssueAllowed;
    _this.beneficialInvestmentsAllowed = beneficialInvestmentsAllowed;
    _this.context = context;
    return _this;
  }
  /**
   * Unserialize string to a Security Token Offering object representation
   *
   * @param serialize - security token's serialized representation
   */


  _createClass(Sto, [{
    key: "toPojo",

    /**
     * Convert entity to a POJO (Plain Old Javascript Object)
     */
    value: function toPojo() {
      var uid = this.uid,
          securityTokenId = this.securityTokenId,
          address = this.address,
          securityTokenSymbol = this.securityTokenSymbol,
          fundraiseCurrencies = this.fundraiseCurrencies,
          raisedFundsWallet = this.raisedFundsWallet,
          unsoldTokensWallet = this.unsoldTokensWallet,
          raisedAmount = this.raisedAmount,
          soldTokensAmount = this.soldTokensAmount,
          investorCount = this.investorCount,
          startDate = this.startDate,
          endDate = this.endDate,
          capReached = this.capReached,
          isFinalized = this.isFinalized,
          isPaused = this.isPaused,
          preIssueAllowed = this.preIssueAllowed,
          beneficialInvestmentsAllowed = this.beneficialInvestmentsAllowed;
      return {
        uid: uid,
        securityTokenId: securityTokenId,
        address: address,
        securityTokenSymbol: securityTokenSymbol,
        fundraiseCurrencies: fundraiseCurrencies,
        raisedFundsWallet: raisedFundsWallet,
        unsoldTokensWallet: unsoldTokensWallet,
        raisedAmount: raisedAmount,
        soldTokensAmount: soldTokensAmount,
        investorCount: investorCount,
        startDate: startDate,
        endDate: endDate,
        capReached: capReached,
        isFinalized: isFinalized,
        isPaused: isPaused,
        preIssueAllowed: preIssueAllowed,
        beneficialInvestmentsAllowed: beneficialInvestmentsAllowed
      };
    }
    /**
     * Hydrate the entity
     */

  }, {
    key: "_refresh",
    value: function _refresh(params) {
      var securityTokenSymbol = params.securityTokenSymbol,
          startDate = params.startDate,
          endDate = params.endDate,
          fundraiseCurrencies = params.fundraiseCurrencies,
          raisedFundsWallet = params.raisedFundsWallet,
          unsoldTokensWallet = params.unsoldTokensWallet,
          raisedAmount = params.raisedAmount,
          soldTokensAmount = params.soldTokensAmount,
          investorCount = params.investorCount,
          isPaused = params.isPaused,
          capReached = params.capReached,
          isFinalized = params.isFinalized,
          preIssueAllowed = params.preIssueAllowed,
          beneficialInvestmentsAllowed = params.beneficialInvestmentsAllowed;

      if (securityTokenSymbol) {
        this.securityTokenSymbol = securityTokenSymbol;
      }

      if (startDate) {
        this.startDate = startDate;
      }

      if (endDate) {
        this.endDate = endDate;
      }

      if (fundraiseCurrencies) {
        this.fundraiseCurrencies = fundraiseCurrencies;
      }

      if (raisedFundsWallet) {
        this.raisedFundsWallet = raisedFundsWallet;
      }

      if (unsoldTokensWallet) {
        this.unsoldTokensWallet = unsoldTokensWallet;
      }

      if (raisedAmount) {
        this.raisedAmount = raisedAmount;
      }

      if (soldTokensAmount) {
        this.soldTokensAmount = soldTokensAmount;
      }

      if (investorCount) {
        this.investorCount = investorCount;
      }

      if (isPaused !== undefined) {
        this.isPaused = isPaused;
      }

      if (capReached !== undefined) {
        this.capReached = capReached;
      }

      if (isFinalized !== undefined) {
        this.isFinalized = isFinalized;
      }

      if (preIssueAllowed !== undefined) {
        this.preIssueAllowed = preIssueAllowed;
      }

      if (beneficialInvestmentsAllowed !== undefined) {
        this.beneficialInvestmentsAllowed = beneficialInvestmentsAllowed;
      }
    }
  }], [{
    key: "unserialize",
    value: function unserialize(serialized) {
      var unserialized = utils_1.unserialize(serialized);

      if (!isUniqueIdentifiers(unserialized)) {
        throw new PolymathError_1.PolymathError({
          code: types_1.ErrorCode.InvalidUuid,
          message: 'Wrong STO ID format'
        });
      }

      return unserialized;
    }
  }]);

  return Sto;
}(Entity_1.Entity);

exports.Sto = Sto;